import { purifyMarkup } from './DomPurifyService';
import {getToken} from './authservice'

function imageUrl (url:string, width:number):string {
    return url
        ? purifyMarkup(url) + '?width=' + width + '&height='+ width +'&rmode=min&quality=70&access_token=' + getToken()
        : 'img/general/no_profile_picture@2x.png'
}

function validateProfilePicture(url:string|null):string {
    if (url){
        if (url.includes('access_token')) {
            return url;
        }
        return imageUrl(url, 256)
    }
    return 'img/general/no_profile_picture@2x.png'
  }

function onProfileImageFail(e: React.SyntheticEvent) {
    (e.target as HTMLImageElement).src = 'img/general/no_profile_picture@2x.png'
}


function assetUrl (url:string):string {
    return url + '?access_token=' + getToken()
}

export {assetUrl ,imageUrl, validateProfilePicture, onProfileImageFail}